import React from 'react';
import "./MessagesApp.css";
import appLib from "../../../libs/appLib.mjs";
import MessagesToolbar from "./MessagesToolbar.mjs";
import RunningChats from "./RunningChats.mjs";
import ChatArea from "./ChatArea.mjs";

const G = window.glob;

const makeNewState = ( indata, slu ) => {
	const ns = {};
	let lu, data;
	if ( typeof indata === 'undefined' ) {
		data = appLib.imByPlayer();
		lu = (new Date() ).getTime();
	} else if ( indata?.lastupdate ) {
		data = indata.data;
		lu = indata.lastupdate;
	}
	if ( lu && (slu||0) >= lu ) return ns;
	ns.chatlist = { lastupdate: data.lastupdate, data: data.data};
	ns.unread = data.unread;
	ns.lastupdate = lu;
	ns.lastread = lu;
	return ns;
}

const MessagesApp = class extends React.Component {
	constructor(props) {
		super(props);
		this.state = makeNewState();
		this.state.currentbox = 'RunningChats';
		this.state.groups = G.getStatus('Groups') || [];
		this.chatList = this.chatList.bind(this);
		this.openChat = this.openChat.bind(this);
		this.uid=G.generateUid('MessagesApp');
	}
	componentDidMount() {
		G.register('Groups', gs => {
			this.setState({groups: gs || [] });
		}, this.uid);
		G.register('GotoRunningChats', () => {
			this.chatList();
		}, this.uid);
		G.register('NewImReceived', all => {
			const ns = makeNewState(all);
			if ( Object.keys(ns).length ) this.setState(ns);
		}, this.uid);
		G.register('UnreadImCount', () => {
			this.setState({
				unread: appLib.getImUnread(),
				lastread: (new Date() ).getTime()
			});
		}, this.uid);
	}
	componentWillUnmount() {
		G.deregister(this.uid);
	}
	chatList() {
		this.setState({currentbox: 'RunningChats'} );
	}
	openChat(c) {
		this.setState({currentbox: 'ChatArea', chat: c} );
	}
	render() {
		const info = {
			groups: this.state.groups,
			chat: this.state.chat,
			openChat: this.openChat
		}
		return(
			<div className={"MessagesApp "+this.state.currentbox} id={this.uid}>
				<MessagesToolbar {...info} />
				<div className={"AppContainer"}>
					<RunningChats
						chatlist={this.state.chatlist}
						unread={this.state.unread}
						{...info}
					/>
					<ChatArea {...info} />
				</div>
			</div>
		)
	}
}

export default MessagesApp;